import {
  grp_detail_one,
  grp_member_one,
  model_post_report,
  report_detail_model,
} from "assets/images";
import { CustomModal } from "components/modals/ModalBox";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./post-report.css";
import { BsDot } from "react-icons/bs";
import { getReportDetailApi } from "services/report";
import moment from "moment";
import TypographyLimit from "components/TypographyLimit";

const ViewReport = ({ _id, onClose }) => {
  const [state, setState] = useState();

  const fetchReportDetail = async () => {
    try {
      const response = await getReportDetailApi({ _id, type: "FEED" });
      setState(response.data.data);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchReportDetail();
  }, []);

  const feedDetail = state?._feed;
  const groupReportList = state?.reports;

  return (
    <div>
      {/* <CustomModal
        show={true}
        handleClose={onClose}
        className="post_report_detail"
      ></CustomModal> */}

      <CustomModal
        className={"wrap_post_modal wrap_groups_modal"}
        show={true}
        handleClose={onClose}
      >
        <h3>Post Report Detail</h3>
        <div className="wrap_card_groups">
          <div className="card_grp">
            <div className="post_report_header">
              {/* <img
                src={
                  feedDetail?._group?.coverImage
                    ? feedDetail?._group?.coverImage
                    : model_post_report
                }
                alt="Post Report"
              /> */}

              <div className="post_report_rgt">
                {/* <b className="mindful_lft">{feedDetail?._group?.name || ""}</b> */}

                <p className="postedby_rgt">
                  <span className="fs-6" style={{ marginRight: "5px" }}>
                    Posted by:{" "}
                  </span>
                  {feedDetail?.createdBy?.fullName || ""}{" "}
                  <span className="timeee">
                    <BsDot /> {moment(feedDetail?.createdAt).fromNow()}
                  </span>
                </p>
              </div>
            </div>

            <div className="post_reportmodel_detail">
              <img src={grp_detail_one} />
              {/* <span className="tages">Economy</span> */}
              <div className="post_reportmodel_txt">
                <p className="post_reportmodel_heading">
                  {feedDetail?.title || ""}
                </p>

                <p className="post_reportmodel_para">
                  <TypographyLimit
                    className="card-description"
                    limit={50}
                    text={feedDetail?.description}
                    enableReadMore
                  />
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{ maxHeight: "170px", overflowY: "auto" }}
          className="report_model_content"
        >
          {groupReportList?.map((report, index) => (
            <div key={index} style={{ marginBottom: "10px" }}>
              <div className="report_topic">
                <p>Report {index + 1}</p>
              </div>

              <div className="wrap_card_description">
                <b>Description</b>
                <p>{report?.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="btn_wrapper">
          <button className="button delete_btn">Delete Post</button>
          <button className="button remove_btn">Remove Report</button>
        </div>

        {/* <div className="button_wraper">
          <button type="button" className="block">
            Block Group
          </button>
          <button type="button" className="delete">
            Remove Report
          </button>
        </div> */}
      </CustomModal>
    </div>
  );
};

export default ViewReport;
